/**
 * @voltxampere/ui — 7812 +12V fixed linear regulator (Sprint 40-1)
 *
 * TO-220 linear regulator, 12 V output for op-amp / motor-driver
 * supplies. V_in must be ≥ 14 V (V_dropout ~ 2 V). Reuses the
 * dc-source SVG; canonical `voltage-source` engine type.
 *
 * Reference: Fairchild MC7812. Engine zero-diff invariant honored.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const regulator7812 = {
    id: "7812",
    nameTr: "7812 (+12V Sabit, TO-220)",
    nameEn: "7812 (+12V Fixed, TO-220)",
    shortcut: "V",
    category: "source",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "7812",
    schemaType: "voltage-source",
    defaultParams: { voltage: 12 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=regulator-7812.js.map